import { Role } from '@/types/user'

export const isAdmin = (roles = new Array<Role>()) =>
  roles.includes('admin')

export const isBasic = (roles = new Array<Role>()) =>
  roles.includes('basic')
